module.exports = {"data":{"site":{"siteMetadata":{"title":"Witsawa Corporation"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 104
// module chunks = 60335399758886 114276838955818